import {
  getMassiveDependentsExclusionFormat,
  cancelMassiveDependentsExclusion,
  createMassiveDependentsExclusion,
  finishMassiveDependentsExclusion,
  getMassiveDependentsExclusionsOfTicket,
  getMassiveDependentsExclusionDetail,
  getMassiveDependentsExclusionFiles,
  getTicketGroupOptionalFiles,
  presuccessMassiveDependantsExclusion,
  successMassiveDependantsExclusion,
  precancelMassiveDependantsExclusion,
  cancelMassiveDependantsExclusion
} from '../../../../network';

import {
  FETCH_MASSIVE_DEPENDENTS_EXCLUSION_URL,
  SET_MASSIVE_DEPENDENTS_EXCLUSION_URL,
  GET_MASSIVE_DEPENDENTS_EXCLUSION_URL,
  POST_MASSIVE_DEPENDENTS_EXCLUSION,
  FETCH_MASSIVE_DEPENDENTS_EXCLUSION_OF_TICKET,
  POST_MASSIVE_CANCEL_DEPENDENTS_EXCLUSION,
  POST_MASSIVE_FINISH_DEPENDENTS_EXCLUSION,
  FETCH_MASSIVE_DEPENDENTS_EXCLUSION_DETAIL,
  SET_MASSIVE_DEPENDENTS_EXCLUSION_DETAIL,
  GET_MASSIVE_DEPENDENTS_EXCLUSION_DETAIL,
  FETCH_MASSIVE_DEPENDENTS_EXCLUSION_FILE,
  SET_MASSIVE_DEPENDENTS_EXCLUSION_FILE,
  GET_MASSIVE_DEPENDENTS_EXCLUSION_FILE,
  FETCH_TICKET_GROUP_OPTIONAL_FILES,
  SET_TICKET_GROUP_OPTIONAL_FILES,
  GET_TICKET_GROUP_OPTIONAL_FILES,
  MASSIVE_DEPENDANTS_EXCLUSION_PRE_SUCCESS,
  MASSIVE_DEPENDANTS_EXCLUSION_SUCCESS,
  MASSIVE_DEPENDANTS_EXCLUSION_PRE_CANCEL,
  MASSIVE_DEPENDANTS_EXCLUSION_CANCEL
} from './types';

const store = {};
const getDefaultState = () => ({
  dependentsExclusionUrl: '',
  ticketDetail: {},
  ticketFile: {},
  optionalFiles: {}
});

store.state = getDefaultState();

store.getters = {
  [GET_MASSIVE_DEPENDENTS_EXCLUSION_URL](state) {
    return state.dependentsExclusionUrl;
  },
  [GET_MASSIVE_DEPENDENTS_EXCLUSION_DETAIL](state) {
    return state.ticketDetail;
  },
  [GET_MASSIVE_DEPENDENTS_EXCLUSION_FILE](state) {
    return state.ticketFile;
  },
  [GET_TICKET_GROUP_OPTIONAL_FILES](state) {
    return state.optionalFiles;
  }
};

store.mutations = {
  [SET_MASSIVE_DEPENDENTS_EXCLUSION_URL](state, payload) {
    state.dependentsExclusionUrl = payload;
  },
  [SET_MASSIVE_DEPENDENTS_EXCLUSION_DETAIL](state, payload) {
    state.ticketDetail = payload;
  },
  [SET_MASSIVE_DEPENDENTS_EXCLUSION_FILE](state, payload) {
    state.ticketFile = payload.map((a) => {
      return {
        id: a.id,
        key: a.id,
        name: a.name,
        route: a.presignedFile,
        ver: 'Ver más'
      };
    });
  },
  [SET_TICKET_GROUP_OPTIONAL_FILES](state, payload) {
    state.optionalFiles = payload;
  }
};

store.actions = {
  async [FETCH_MASSIVE_DEPENDENTS_EXCLUSION_URL]({ commit }, payload) {
    try {
      const response = await getMassiveDependentsExclusionFormat(
        payload.companyId,
        payload.insuranceCompanyId
      );
      commit(SET_MASSIVE_DEPENDENTS_EXCLUSION_URL, response);
      return response.data;
    } catch (error) {
      throw error(error);
    }
  },
  async [FETCH_MASSIVE_DEPENDENTS_EXCLUSION_OF_TICKET](_, ticketGroupId) {
    const response = await getMassiveDependentsExclusionsOfTicket(
      ticketGroupId
    );
    return response.data;
  },
  async [POST_MASSIVE_DEPENDENTS_EXCLUSION](_, payload) {
    const response = await createMassiveDependentsExclusion(payload);
    return response.data;
  },
  async [POST_MASSIVE_CANCEL_DEPENDENTS_EXCLUSION](_, ticketGroupId) {
    const response = await cancelMassiveDependentsExclusion(ticketGroupId);
    return response.data;
  },
  async [POST_MASSIVE_FINISH_DEPENDENTS_EXCLUSION](_, ticketGroupId) {
    const response = await finishMassiveDependentsExclusion(ticketGroupId);
    return response.data;
  },
  async [FETCH_MASSIVE_DEPENDENTS_EXCLUSION_DETAIL]({ commit }, ticketId) {
    return new Promise((resolve, reject) => {
      getMassiveDependentsExclusionDetail(ticketId).then(
        (resp) => {
          commit(SET_MASSIVE_DEPENDENTS_EXCLUSION_DETAIL, resp.data);
          resolve(resp);
        },
        (err) => {
          reject(err);
        }
      );
    });
  },
  async [FETCH_MASSIVE_DEPENDENTS_EXCLUSION_FILE]({ commit }, ticketId) {
    let error = '';
    const response = await getMassiveDependentsExclusionFiles(ticketId).catch(
      (err) => (error = err)
    );
    if (response && response.status === 200) {
      commit(SET_MASSIVE_DEPENDENTS_EXCLUSION_FILE, response.data);
    } else {
      throw error;
    }
  },
  async [FETCH_TICKET_GROUP_OPTIONAL_FILES]({ commit }, ticketGroupId) {
    try {
      const response = await getTicketGroupOptionalFiles(ticketGroupId);
      if (response && (response.status === 201 || response.status === 200)) {
        commit(SET_TICKET_GROUP_OPTIONAL_FILES, response.data);
      }
    } catch (error) {
      console.error(
        'Error al obtener los archivos opcionales del ticket. FETCH_OPTIONAL_FILES_TICKET_GROUP:',
        error.response.data.message
      );
      throw error.response.data.message;
    }
  },
  async [MASSIVE_DEPENDANTS_EXCLUSION_PRE_SUCCESS](_, payload) {
    let error = '';
    const response = await presuccessMassiveDependantsExclusion(payload).catch(
      (err) => (error = err)
    );
    if (response && (response.status === 201 || response.status === 200)) {
      return response.data;
    }
    throw error;
  },
  async [MASSIVE_DEPENDANTS_EXCLUSION_SUCCESS](_, { ticketGroupId, payload }) {
    let error = '';
    const response = await successMassiveDependantsExclusion(
      ticketGroupId,
      payload
    ).catch((err) => (error = err));
    if (response && (response.status === 201 || response.status === 200)) {
      return response.data;
    }
    throw error;
  },
  async [MASSIVE_DEPENDANTS_EXCLUSION_PRE_CANCEL](_, payload) {
    let error = '';
    const response = await precancelMassiveDependantsExclusion(payload).catch(
      (err) => (error = err)
    );
    if (response && (response.status === 201 || response.status === 200)) {
      return response.data;
    }
    throw error;
  },
  async [MASSIVE_DEPENDANTS_EXCLUSION_CANCEL](_, { ticketGroupId, payload }) {
    let error = '';
    const response = await cancelMassiveDependantsExclusion(
      ticketGroupId,
      payload
    ).catch((err) => (error = err));
    if (response && (response.status === 201 || response.status === 200)) {
      return response.data;
    }
    throw error;
  }
};

export default store;
